/**
 * The shell's baseline English copy, composed from per-feature fragments. This is
 * the default catalog every world inherits; a world overrides any key in its own
 * `WorldConfig.content` (e.g. Zweihänder's grimdark copy, or a `de` locale).
 *
 * It was extracted verbatim from the original (Grymwyrd) components during the
 * P-B i18n sweep — so Grymwyrd's copy IS this baseline, and the shell's unit
 * tests render real English against it.
 */
import { layoutEn } from './en/layout'
import { homeEn } from './en/home'
import { playEn } from './en/play'
import { demoEn } from './en/demo'
import { booksEn } from './en/books'
import { commerceEn } from './en/commerce'
import { communityEn } from './en/community'
import { dashboardEn } from './en/dashboard'
import { authEn } from './en/auth'
import { marketingEn } from './en/marketing'
import { worldEn } from './en/world'
import { encyclopediaEn } from './en/encyclopedia'
import { systemEn } from './en/system'
import { mapBuilderEn } from './en/mapbuilder'
import { cityEn } from './en/city'
import type { MessageCatalog } from '@gamecodex/world-config'

export const baseEn: MessageCatalog = {
  ...layoutEn,
  ...homeEn,
  ...playEn,
  ...demoEn,
  ...booksEn,
  ...commerceEn,
  ...communityEn,
  ...dashboardEn,
  ...authEn,
  ...marketingEn,
  ...worldEn,
  ...encyclopediaEn,
  ...systemEn,
  ...mapBuilderEn,
  ...cityEn,
}
